import { gql } from '@apollo/client';

export const updateFacilityNotepadEntry = gql`
  mutation updateFacilityNotepadEntry(
    $id: String
    $input: UpdateFacilityNotepadEntry
  ) {
    updateFacilityNotepadEntry(id: $id, input: $input) {
      id
      categoryId
      note
      archived
      createdBy
      createdAt
      Category {
        id
        name
      }
    }
  }
`;
